exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header{width:100%;border-radius:0;margin-bottom:0!important;background-color:#fff;height:60px}.header-logo{height:60px!important;line-height:60px}.header-logo img{display:block;height:34px}.header .glyphicon{color:#fff;margin-right:8px;font-size:1pc}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/Header/style.css
 ** module id = 1963
 ** module chunks = 73
 **/